'use client';

import { useParams, usePathname, useRouter, useSearchParams } from 'next/navigation';

import { useTransCommon } from '@/@shared/hooks/useTranslations';
import Icon from '@/Icon';
import styles from '@/legacy/components/modalContents/SetLanguage.module.scss';

const languages = [
	{ key: 'en', label: 'English' },
	{ key: 'es', label: 'Español' },
	{ key: 'id', label: 'Bahasa Indonesia' },
	{ key: 'ja', label: '日本語' },
	{ key: 'ko', label: '한국어' },
	{ key: 'ms', label: 'Bahasa Melayu' },
	{ key: 'th', label: 'ไทย' },
	{ key: 'vi', label: 'Tiếng Việt' },
	{ key: 'zh-cn', label: '简体中文' },
	{ key: 'zh-tw', label: '繁體中文(台灣)' },
	{ key: 'de', label: 'Deutsch' },
	{ key: 'fr', label: 'Français' },
	{ key: 'mn', label: 'Монгол' },
];

type Props = {
	locale: string;
	closeModal: () => void;
};

const SetLanguage = ({ locale, closeModal }: Props) => {
	const router = useRouter();
	const pathname = usePathname();
	const params = useParams<{ locale: string }>();
	const searchParams = useSearchParams();

	console.log('pathname:', pathname, params);

	const t = useTransCommon('temp.modal');

	const handleLanguageChange = (newLocale: string) => {
		localStorage.setItem('preferredLocale', newLocale);
		const newPath = pathname.replace(params.locale, newLocale);
		const queryString = searchParams.toString();
		const fullPath = queryString ? `${newPath}?${queryString}` : newPath;
		router.push(fullPath);
	};

	const getSelectedLanguageLabel = () => {
		const selectedLanguage = languages.find((language) => language.key === locale);
		return selectedLanguage ? selectedLanguage.label : locale;
	};

	const handleClose = () => {
		closeModal();
	};

	return (
		<div className={styles.space}>
			<div className={styles.wrap}>
				<button className={styles.prevIcon} onClick={handleClose}>
					<Icon className={styles.prevIcon} color1={'#FDFDFE'} path="Navi_Chevron_24_White_Left" />
				</button>
				<span className={styles.title}>{t('languageChange')}</span>
				<div className={styles.prevIcon} />
			</div>

			<div className={styles.selected}>
				<span className={styles.radioLabel}>{getSelectedLanguageLabel()}</span>
			</div>
			<hr />

			<div className={styles.frame}>
				{languages.map((language) => (
					<button className={styles.label} key={language.key} onClick={() => handleLanguageChange(language.key)}>
						<span className={styles.radioLabel}>{language.label}</span>
						{locale === language.key && (
							<Icon className={styles.linkIcon} color1={'#FDFDFE'} path="Action_Check_24_Black" />
						)}
					</button>
				))}
			</div>
		</div>
	);
};

export default SetLanguage;
